export enum GateDefinitionEnum {
  InBound = 'IN_BOUND',
  OutBound = 'OUT_BOUND',
  Both = 'BOTH'
}
